// Cache simples em memória, vivo só durante a sessão da aba. Guarda a última
// resposta bem-sucedida de uma rota para exibir na hora ao revisitar uma tela
// já carregada antes, enquanto os dados são revalidados em segundo plano —
// sem isso, toda troca de tela mostra o spinner de novo mesmo com dado recente.
const cache = new Map();

export function getCached(key) {
  return cache.has(key) ? cache.get(key) : undefined;
}

export function setCached(key, value) {
  cache.set(key, value);
}
